import React from 'react';

/**
 * Small status pill. Mirrors the prototype's `.badge` + `.mint` / `.gold` /
 * `.coral` / `.dim` variants.
 *
 *  <Badge tone="mint">Active</Badge>
 *  <Badge tone="gold">Pending</Badge>
 *  <Badge tone="coral">Rejected</Badge>
 *  <Badge>—</Badge>           // renders as "badge dim"
 */
const Badge = ({tone, children, className = '', ...rest}) => {
    // Default to "dim" (the prototype's neutral variant) when no tone is given.
    const variant = tone || 'dim';
    const cn = ['badge', variant, className].filter(Boolean).join(' ');
    return (
        <span className={cn} {...rest}>
            {children}
        </span>
    );
};

export default Badge;
